import { rotatedEllipseHalfExtents } from "./cup-box-assignment";
/*
 * The cup's rotated outline itself, no margin — what the gap between
 * neighbouring copies is measured from, so a gap of 0 means touching cups.
 * The margin is about the part's edges, not about other cups.
 */
var cupOutlineHalfExtents = function (cup) {
    return rotatedEllipseHalfExtents(cup.width / 2, cup.depth / 2, cup.rotationY);
};
/*
 * A pointer resting a hair short of a whole step (floating point, or the user
 * aiming at the previous cup's centre) still counts that step.
 */
var stepEpsilon = 1e-6;
var cellCount = function (distance, pitch) {
    return pitch > 0 ? Math.floor(Math.abs(distance) / pitch + stepEpsilon) + 1 : 1;
};
export var computeCupGridFill = function (_a) {
    var anchor = _a.anchor, target = _a.target, pitch = _a.pitch, limit = _a.limit;
    var dx = target.x - anchor.x;
    var dz = target.z - anchor.z;
    var columns = cellCount(dx, pitch.x);
    var rows = cellCount(dz, pitch.z);
    var stepX = Math.sign(dx) * pitch.x;
    var stepZ = Math.sign(dz) * pitch.z;
    /* Row by row away from the anchor, so when the limit cuts the grid short
     * the part that is created is the part nearest the anchor: complete rows,
     * then a partial one. */
    var cells = [];
    for (var row = 0; row < rows; row++) {
        for (var column = 0; column < columns; column++) {
            if (row === 0 && column === 0)
                continue; // the anchor itself
            cells.push({
                x: anchor.x + column * stepX,
                z: anchor.z + row * stepZ,
            });
        }
    }
    var allowed = Math.max(0, Math.floor(limit));
    return {
        columns: columns,
        rows: rows,
        placed: cells.slice(0, allowed),
        overflow: cells.slice(allowed),
    };
};
/*
 * Centre-to-centre distance between neighbouring copies with `gap` of clear
 * space between their outlines, per axis — the axes differ for an oval cup,
 * so the clear space is the same all round.
 */
export var cupGridPitch = function (cup, gap) {
    var extents = cupOutlineHalfExtents(cup);
    return { x: 2 * extents.x + gap, z: 2 * extents.z + gap };
};
/*
 * The gap a fill starts out with: one cup-width of clear space, the cup's
 * longer side, rounded up to a whole millimetre so the value in the panel is
 * not a floating-point tail. Rounded in millimetres (with a hair of
 * tolerance, so 75.00000000000001 mm is 75, not 76) and divided back, which
 * lands on the exact decimal.
 */
export var defaultCupGap = function (cup) {
    return Math.ceil(Math.max(cup.width, cup.depth) * 1000 - 1e-6) / 1000;
};
